export enum CertificatesTypes {
  external = 'external',
  internal = 'internal',
}

export const prefix = 'home.lmsIndex.lmsCertificates'
